<template>
  <div class="carousel" ref="carousel">
    <div class="carousel-track" ref="track">
      <div class="slide" v-for="(image, index) in images" :key="index" :data-index="index">
        <a :href="image.destUrl" @click="!image.destUrl && $event.preventDefault()" target="_blank">
          <img :src="image.content" />
        </a>
      </div>
    </div>

    <div class="dots">
      <span
        class="dot"
        v-if="totalSlides > 0"
        v-for="(_, i) in totalSlides"
        :key="i"
        :class="{ active: i === currentIndex }"
        @click="goToSlide(i)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default () {
        return []
      }
    },
    nextSlideMs: {
      type: Number,
      default: 10000
    },
    transitionDurationMs: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      currentIndex: 0,
      intervalId: null,
      visibleSlides: 4
    }
  },
  computed: {
    totalSlides () {
      return this.images.length
    }
  },
  methods: {
    startAutoSlide () {
      this.intervalId = setInterval(this.nextSlide, this.nextSlideMs)
    },
    animate () {
      const track = this.$refs.track
      const item = track.children[0]
      const offset = item.offsetWidth

      track.style.transition = 'none'
      track.style.transform = `translateX(0)`

      void track.offsetWidth

      track.style.transition = `transform ${this.transitionDurationMs / 1000}s ease`
      track.style.transform = `translateX(-${offset}px)`
    },
    nextSlide () {
      const track = this.$refs.track
      const item = track.children[0]

      this.animate()

      setTimeout(() => {
        track.appendChild(item)
        track.style.transition = 'none'
        track.style.transform = 'translateX(0)'
      }, this.transitionDurationMs)

      this.currentIndex = (this.currentIndex + 1) % this.totalSlides
    },
    prevSlide () {
      const track = this.$refs.track
      const items = track.children
      const item = items[items.length - 1]
      track.prepend(item)
      track.style.transition = 'none'
      track.style.transform = `translateX(-${items[0].offsetWidth}px)`

      void track.offsetWidth

      track.style.transition = `transform ${this.transitionDurationMs / 1000}s ease`
      track.style.transform = 'translateX(0)'

      this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides
    },
    goToSlide (targetIndex) {
      if (targetIndex === this.currentIndex || this.visibleSlides >= this.totalSlides) return

      clearInterval(this.intervalId)

      const forwardSteps = (targetIndex - this.currentIndex + this.totalSlides) % this.totalSlides
      const backwardSteps = (this.currentIndex - targetIndex + this.totalSlides) % this.totalSlides

      const direction = forwardSteps <= backwardSteps ? 'next' : 'prev'
      const steps = Math.min(forwardSteps, backwardSteps)

      const stepSlide = (i = 0) => {
        if (i < steps) {
          direction === 'next' ? this.nextSlide() : this.prevSlide()
          setTimeout(() => stepSlide(i + 1), this.transitionDurationMs)
        } else {
          this.startAutoSlide()
        }
      }

      stepSlide()
    },
    setResponsiveSlides () {
      clearInterval(this.intervalId)
      const width = window.innerWidth
      if (width > 1440) {
        this.visibleSlides = 4
      } else if (width > 1024) {
        this.visibleSlides = 3
      } else if (width >= 768) {
        this.visibleSlides = 2
      } else {
        this.visibleSlides = 1
      }
      const track = this.$refs.track
      const item = track.children[0]
      this.currentIndex = (Number(item.dataset.index) + this.totalSlides) % this.totalSlides
      if (this.visibleSlides < this.totalSlides) {
        this.startAutoSlide()
      }
    }
  },
  mounted () {
    if (this.totalSlides > 0) {
      this.setResponsiveSlides()
      window.addEventListener('resize', this.setResponsiveSlides)
    }
  },
  beforeUnmount () {
    clearInterval(this.intervalId)
    window.removeEventListener('resize', this.setResponsiveSlides)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
    window.removeEventListener('resize', this.setResponsiveSlides)
  }
}
</script>

<style scoped>
.carousel {
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}

.carousel-track {
  display: flex;
  transition: transform 1s ease;
}

.slide {
  flex: 0 0 calc(100% / 4);
  padding: 12px;
}

.slide img {
  width: 100%;
}

.dots {
  text-align: center;
  margin-top: 12px;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background-color: #ccc;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background-color: #333;
}

@media (max-width: 1440px) {
  .slide {
    flex: 0 0 calc(100% / 3);
  }
}

@media (max-width: 1024px) {
  .slide {
    flex: 0 0 calc(100% / 2);
  }
}

@media (max-width: 767px) {
  .slide {
    flex: 0 0 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue